import classes from "./Settings.module.css"
import Select from "react-select"
import { useTranslation } from "react-i18next"
import { default_single_style, generate_brands, generate_drinks } from "../../Utils"

const Settings = props => {
    const { t } = useTranslation()
    const brands = generate_brands(t, true)
    const abilities = generate_drinks(t)

    const centerStyle = default_single_style()

    return (
        <div className={classes.SettingsContent}>
            <p>{t("misc:Checker.HaveBrand")}</p>
            <p>
                <strong>{t("translation:LayoutMsg.Cmn_CstBase_00.002")}:</strong>
            </p>
            <Select
                value={props.currentBrand}
                onChange={props.brandChange}
                options={brands}
                styles={centerStyle}
                formatOptionLabel={elem => {
                    const url = `https://leanny.github.io/splat3/images/brand/${elem.value}.png`
                    return (
                        <>
                            <img src={url} width="32" alt={elem.label} className={classes.Brand} />
                            <span className={classes.Gap}> {elem.label}</span>
                        </>
                    )
                }}
            />
            <p>
                <strong>{t("translation:LayoutMsg.Lobby_Shop_00.T_Drink_00")}:</strong>
            </p>
            <Select
                value={props.currentDrink}
                onChange={props.drinkChange}
                options={abilities}
                styles={centerStyle}
                formatOptionLabel={elem => {
                    const url = `https://leanny.github.io/splat3/images/skill/${elem.value}.png`
                    return (
                        <>
                            {elem.value !== "None" ? (
                                <img src={url} width="32" alt={elem.label} className={classes.Ability} />
                            ) : (
                                ""
                            )}
                            <span className={classes.Gap}> {elem.label}</span>
                        </>
                    )
                }}
            />
        </div>
    )
}

export default Settings

/*
https://api.lp1.av5ja.srv.nintendo.net/api/graphql
{"variables":{},"extensions":{"persistedQuery":{"version":1,"sha256Hash":"7d8b560e31617e981cf7c8aa1ca13a00"}}}
*/
